import { put, call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadPaymentMethodListFailed,
  loadPaymentMethodListSuccessful,
  loadPaymentMethodListBegin,
} from '../actions';

export default function* loadPaymentMethodList(action) {
  try {
    const url = `${BACKEND_URL}/payment-methods`;
    yield put(loadPaymentMethodListBegin());
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      data.result = data.data;
      yield put(loadPaymentMethodListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadPaymentMethodListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadPaymentMethodListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
